var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"main"}},[(_vm.isLoadingScreen)?_c('LoadingCommon'):(_vm.settingError !== '')?_c('div',{staticClass:"error-settings"},[_vm._v(_vm._s(_vm.settingError))]):[_c('NavCommon'),_c('router-view'),_c('Confirm')]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }